export default __webpack_public_path__ + "static/media/amazon1.0fdd4d99.png";